import { useTranslation } from "hhn-commons";
import {
  ForwardedIcon,
  ForwardedMessageBox,
  ForwardedText,
  InfoIconContainer,
} from "../MessagePanel.style";
import { InfoTooltip } from "../../common/InfoTooltip";
import { IMessage } from "@home-health-notify/domain";

interface MessageForwardedInfoProps {
  message: IMessage;
}

const MessageForwardedInfo = ({ message }: MessageForwardedInfoProps) => {
  const { t } = useTranslation();
  const tNAdvanceSearch = (key: string) => t(key, { ns: "message" });
  const senderName = message.getMessage()?.forwardedFrom?.senderName;

  return (
    <ForwardedMessageBox data-testid="forwarded-message-header">
      <ForwardedIcon />
      <ForwardedText>
        &nbsp;{tNAdvanceSearch("forwardedMessage")}&nbsp;
      </ForwardedText>
      {senderName && (
        <InfoTooltip
          title={`
        ${tNAdvanceSearch("forwardedFrom")} 
        ${senderName}
        `}
          arrow
          data-testid="info-tooltip"
        >
          <InfoIconContainer />
        </InfoTooltip>
      )}
    </ForwardedMessageBox>
  );
};

export default MessageForwardedInfo;
